import styled from 'styled-components';

import { tokens as visualAssetTokens } from '../VisualAsset/tokens';

export const StyledThumbnail = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background: ${visualAssetTokens.fallback.gradient};
`;
